import {
  CognitiveKind,
  CognitiveTestAssessmentStageActionCandidateStatus,
  EnglishProficiencyAssessmentStageActionCandidateStatus,
  PersonalityTestAssessmentStageActionCandidateStatus,
  TestStatus,
} from 'generated/graphql';
import { TestKind } from 'enums/tests';

/**
 * The new assessment action candidates share the legacy TestStatus values
 * (NOT_STARTED / IN_PROGRESS / COMPLETED) — map them across so the shared
 * TestIntro keeps its start-vs-continue CTA behaviour.
 */
export const actionCandidateStatusToTestStatus = (
  status:
    | PersonalityTestAssessmentStageActionCandidateStatus
    | CognitiveTestAssessmentStageActionCandidateStatus
    | EnglishProficiencyAssessmentStageActionCandidateStatus
): TestStatus =>
  ({
    NOT_STARTED: TestStatus.NotStarted,
    IN_PROGRESS: TestStatus.InProgress,
    COMPLETED: TestStatus.Completed,
  })[status];

export const cognitiveKindToTestKind: Record<CognitiveKind, TestKind> = {
  [CognitiveKind.Inductive]: TestKind.CognitiveInductive,
  [CognitiveKind.Numerical]: TestKind.CognitiveNumerical,
  [CognitiveKind.Verbal]: TestKind.CognitiveVerbal,
};
